const articlesGalleryContainer = document.querySelector('.articles-gallery .gallery-container')
const articlesCategoryButtons = document.querySelectorAll('.articles-gallery .category-button')
const articlesArticleCards = document.querySelectorAll('.articles-gallery .article-card')

let isGridAnimating = false


if (articlesGalleryContainer) {
	articlesCategoryButtons.forEach(button => {
		button.addEventListener('click', () => {
			if (isGridAnimating) return
			
			const currentCategory = button.dataset.category
			const currentActiveButton = document.querySelector('.articles-gallery .category-button.active')
			if (currentActiveButton === button) return
			
			articlesCategoryButtons.forEach(btn => btn.classList.remove('active'))
			button.classList.add('active')
			
			isGridAnimating = true
			
			// Capture initial height and lock it
			const startHeight = articlesGalleryContainer.offsetHeight
			articlesGalleryContainer.style.height = `${startHeight}px`
			
			// Fade out current visible cards
			articlesGalleryContainer.classList.add('fading-out')
			
			setTimeout(() => {
				// Update active states
				articlesArticleCards.forEach(card => {
					if (currentCategory === 'all' || card.dataset.category.includes(currentCategory)) {
						card.classList.add('active')
					} else {
						card.classList.remove('active')
					}
				})
				
				// Measure new natural height
				articlesGalleryContainer.style.height = 'auto'
				const endHeight = articlesGalleryContainer.offsetHeight
				
				// Set back to start height, then animate to end height
				articlesGalleryContainer.style.height = `${startHeight}px`
				articlesGalleryContainer.offsetHeight // force reflow
				articlesGalleryContainer.style.height = `${endHeight}px`
				
				// Fade in new visible cards
				articlesGalleryContainer.classList.remove('fading-out')
				articlesGalleryContainer.classList.add('fading-in')
				
				setTimeout(() => {
					articlesGalleryContainer.classList.remove('fading-in')
					articlesGalleryContainer.style.height = ''
					isGridAnimating = false
				}, 300)
			}, 300)
		})
	})
}